import React from 'react'
import { useApp } from '../../../context/AppProvider'
import { Parser } from '../../common'
import Link from '../link/Link'

const Image = ({ block }) => {
    const { validateSelection } = useApp()
    return (
        !validateSelection && (
            <>
                <div className="baseocom-image-block">
                    <img src={block?.attributes?.LienPublication} alt="fiche" />
                    <p>Crédits : Direction de l'information légale et administrative</p>
                    <Link targetBlank={true} url={block?.attributes?.LienPublication} isIcon={true}>
                        Ouvrir l'image dans un nouvel onglet
                    </Link>
                </div>

                {block?.childrens && <Parser content_block={block?.childrens} />}
            </>
        )
    )
}

export default Image
